import { cacheAddNewCallerId } from '@/graphql/cache/cache-mutations';
import { callerIdVerificationSubscription, usecallerIdVerificationSubscription } from '@/types/generated/graphql';
import { custom_events } from '@shared/constants';
import { notification } from 'antd';

export const useCallerIdVerificationSubscription = () => {
  usecallerIdVerificationSubscription({
    onData: (res) => {
      handleOnData({
        data: res?.data?.data as callerIdVerificationSubscription,
      });
      const e = new CustomEvent(custom_events.caller_id_verified, { detail: res });
      window.dispatchEvent(e);
    },
    onError: (err) => {
      notification.error({ message: err?.message });
    },
  });
};

function handleOnData({ data }: { data: callerIdVerificationSubscription }) {
  if (!data?.callerIdVerification) return;

  cacheAddNewCallerId(data.callerIdVerification);
}
